// extracted by mini-css-extract-plugin
var _1 = "styles_description__FQpdU";
var _2 = "styles_group__YN654";
var _3 = "styles_notification__hl7hU";
var _4 = "styles_snack__O8H1O";
var _5 = "styles_title__usLkG";
export { _1 as "description", _2 as "group", _3 as "notification", _4 as "snack", _5 as "title" }
